import React from 'react';

interface VoiceMailIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const VoiceMailIcon: React.FC<VoiceMailIconProps> = ({
  width = 20,
  height = 20,
  className = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.83333 8.33317C4.91286 8.33317 4.16667 9.07936 4.16667 9.99984C4.16667 10.9203 4.91286 11.6665 5.83333 11.6665C6.75381 11.6665 7.5 10.9203 7.5 9.99984C7.5 9.07936 6.75381 8.33317 5.83333 8.33317ZM2.5 9.99984C2.5 8.15889 3.99238 6.6665 5.83333 6.6665C7.67428 6.6665 9.16667 8.15889 9.16667 9.99984C9.16667 11.8408 7.67428 13.3332 5.83333 13.3332C3.99238 13.3332 2.5 11.8408 2.5 9.99984Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.1667 8.33317C13.2462 8.33317 12.5 9.07936 12.5 9.99984C12.5 10.9203 13.2462 11.6665 14.1667 11.6665C15.0871 11.6665 15.8333 10.9203 15.8333 9.99984C15.8333 9.07936 15.0871 8.33317 14.1667 8.33317ZM10.8333 9.99984C10.8333 8.15889 12.3257 6.6665 14.1667 6.6665C16.0076 6.6665 17.5 8.15889 17.5 9.99984C17.5 11.8408 16.0076 13.3332 14.1667 13.3332C12.3257 13.3332 10.8333 11.8408 10.8333 9.99984Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 12.4998C5 12.0396 5.3731 11.6665 5.83333 11.6665H14.1667C14.6269 11.6665 15 12.0396 15 12.4998C15 12.9601 14.6269 13.3332 14.1667 13.3332H5.83333C5.3731 13.3332 5 12.9601 5 12.4998Z"
      fill="currentColor"
    />
  </svg>
);

